export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'Location'
    ],
    'consulting': [
      'Company',
      'Location',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'Location',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'Location',
      'RequestTopic'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'Location'
    ],
    'other': [
      'Location'
    ]
  }
}
